// Imports are same for Profile and Vertical card
import { useBlockProps, BlockControls, InnerBlocks, RichText } from "@wordpress/block-editor";
import { ToolbarGroup, Button as WPButton } from "@wordpress/components";
import SidePanel from "./sidePanel";
import { __ } from "@wordpress/i18n"; // Use WordPress i18n for localization
import { t } from "drupal";
import { TextControl } from "@wordpress/components";
import { useState, useEffect, useCallback } from "@wordpress/element";
import { useSelect, useDispatch } from '@wordpress/data';
import { handleUrlChange2, sanitizeInput, sanitizeKeepHTML, isValidDomain } from '../utilities/helpers';


export default function Edit({ attributes, setAttributes, clientId }) {

  const { linkUrl,
          linkText,
          sizeSlug = "hero_bgmobile",
          ariaLabel = "",
          linkTextError = "",
          linkUrlError = "",
          imageError = ""
        } = attributes;

  const ALLOWED_BLOCKS = ['core/image'];
  const TEMPLATE = [
    ['core/image', {}]
  ];

  // Strip out HTML and script for title
  const onChangeLink = (value) => {
    const cleanedText = sanitizeInput(value);
    setAttributes({ linkUrl: cleanedText });
  };


  /* Strip out HTML and script for CTA. Limit characters to 70 because
     too many chars will appear outside the image backed card
  */
  const onChangeLinkText = (value) => {
    const cleanedText = sanitizeInput(value);
    const limitedText = cleanedText.slice(0, 70); // max 70 chars
    setAttributes({ linkText: limitedText });
  };


  // Access the inner blocks
  const { replaceInnerBlocks } = useDispatch('core/block-editor');
  const innerBlocks = useSelect(
    (select) => select('core/block-editor').getBlocks(clientId),
    [clientId]
  );

  // Preselect the 'hero_bgmobile' resolution for core/image
  useEffect(() => {
    // If no inner block exists, insert one
    if (innerBlocks.length === 0) {
      const newBlock = wp.blocks.createBlock('core/image', {
        sizeSlug: 'hero_bgmobile', // Set the default resolution
      });
      replaceInnerBlocks(clientId, [newBlock], false);
    } else {
      // Update existing inner block if needed
      const innerBlock = innerBlocks[0];
      if (innerBlock.attributes.sizeSlug !== 'hero_bgmobile') {
        wp.data.dispatch('core/block-editor').updateBlockAttributes(
          innerBlock.clientId,
          { sizeSlug: 'hero_bgmobile' }
        );
      }
    }
  }, [innerBlocks, replaceInnerBlocks, clientId]);


  /**
   * If the user presses Enter or Tab, update the URL
   **/

    const handleKeyDown = useCallback((event) => {
      if ((event.key === 'Enter' || event.key === 'Tab') && linkUrl) {
        //handleUrlChange2 is from /deohs_gutenberg_blocks/blocks/utilities/helpers.js
        const updatedUrl = handleUrlChange2(linkUrl);
        if (updatedUrl !== linkUrl) { // Prevent unnecessary updates
          setAttributes({ linkUrl: updatedUrl });
        }
      }
    }, [linkUrl, setAttributes]);

  /**
   * Dynamically checks for requried fields, update attributes with error flags that validation.js watches, and auto disable
   * save button when missing linktext, linkURL, or iamge
   **/

  useEffect(() => {
    const imgElements = document.querySelectorAll(
      `#block-${clientId} figure.wp-block-image img[src]`
    );
    const hasValidImage = imgElements.length > 0;

    // const linkTextError = !linkText?.trim();
    const linkTextError = !linkText?.trim() || linkText.trim().length > 70;
    const linkUrlError = !isValidDomain(linkUrl);
    const imageError = !hasValidImage;

    // console.log("edit.js validation state", {
    //   linkTextError,
    //   linkUrlError,
    //   imageError,
    // });

    setAttributes({
      hasValidImage,
      linkTextError,
      linkUrlError,
      imageError,
    });
  }, [linkText, linkUrl, innerBlocks]);


  return (
    <div {...useBlockProps()}>
      <BlockControls>
        <ToolbarGroup>
          <WPButton label={__("Image-Backed Card Settings")} icon="heading" disabled />
        </ToolbarGroup>
      </BlockControls>


      {/* Show error message in red text above image backed card if missing any required fields */}
      {(linkTextError || linkUrlError || imageError) && (
        <div className="editor-field-error-message">
          {linkTextError && linkUrlError && imageError
            ? t("Link text, Valid Link URL, and an image are required")
            : linkTextError && linkUrlError
              ? t("Link text and Valid Link URL are required")
              : linkUrlError && imageError
                ? t("Valid Link URL and an image are required")
                : linkTextError && imageError
                  ? t("Link text and an image are required")
                  : imageError
                    ? t("An image is required")
                    : linkUrlError
                      ? t("Valid Link URL is required")
                      : linkTextError
                        ? t("Link text is required")
                        : ""}
        </div>
      )}
      <div className="col">
       <div className="card">
          <InnerBlocks
            template={TEMPLATE}
            allowedBlocks={ALLOWED_BLOCKS}
            templateLock="insert"
          />
          <div className="card-img-overlay">
            <TextControl
              label={t("Card Link URL")}
              className={`${linkUrlError ? "editor-field-error is-required" : ""}`}
              value={linkUrl}
              onChange={onChangeLink}
              onBlur={() => {
                if (linkUrl) {
                  const updatedUrl = handleUrlChange2(linkUrl);
                  if (updatedUrl !== linkUrl) {
                    setAttributes({ linkUrl: updatedUrl });
                  }
                }
              }}
              onKeyDown={handleKeyDown}
              placeholder={t("/about or example.com")}
            />
            <TextControl
              label={t("Link Text")}
              className={`${linkTextError ? "editor-field-error is-required" : ""}`}
              value={linkText}
              placeholder={t("Learn more (70 chars max)")}
              onChange={(value) => {
                const trimmedValue = value?.trim() ?? "";
                onChangeLinkText(value, "linkText");
              }}
            />
          </div>
        </div>
      </div>
      <SidePanel
        linkUrl={linkUrl}
        linkText={linkText}
        ariaLabel={ariaLabel}
        onChangeLink={onChangeLink}
        onChangeLinkText={onChangeLinkText}
        setAttributes={setAttributes} />
    </div>
  );
}
